import { FatalError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class FatalMissingContextError extends FatalError {
  static override locales: Locales = {
    'en-US': '%s is missing %s context in %s process',
    'zh-CN': '%s 在 %s 过程中缺少必要的 %s 上下文',
    'zh-HK': '%s 在 %s 過程中缺少必要的 %s 上下文'
  }

  override name = 'FatalMissingContextError' as const

  constructor(target: string, context: string, process: string) {
    super(target, context, process)
  }
}
